import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LabelsService } from '../../../services/http/labels/labels.service';
import { Label } from '../../../services/http/labels/labels.interface';

@Component({
  selector: 'app-tags',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tags.component.html',
  styleUrl: './tags.component.scss'
})
export class TagsComponent {
  labels: Label[] = [];

  constructor(
    private labelsService: LabelsService
  ) {
    this.labelsService.getLabels().subscribe(labels => {
      this.labels = labels.labels;
    });
  }
}
